document.addEventListener('DOMContentLoaded', () => {
    // Automatically hide the alert after 4 seconds with a fade-out transition
    setTimeout(() => {
        const alertMessage = document.getElementById('alertMessage');
        if (alertMessage) {
            alertMessage.classList.add('opacity-0');
            setTimeout(() => {
                alertMessage.style.display = 'none';
            }, 1000); // Match the transition duration (1 second)
        }
    }, 4000);

    // Use Flowbite Dismiss to handle the dismiss action
    const $targetEl = document.getElementById('alertMessage');
    const $triggerEl = document.getElementById('triggerElement');

    // Flowbite dismiss options
    const options = {
        transition: 'transition-opacity',
        duration: 1000,
        timing: 'ease-out',
        onHide: (context, targetEl) => {
            console.log('element has been dismissed');
            console.log(targetEl);
        }
    };

    // Initialize Dismiss instance
    if ($targetEl && $triggerEl) {
        const dismiss = new Dismiss($targetEl, $triggerEl, options);
        $triggerEl.addEventListener('click', () => dismiss.hide());
    }
});
